import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { IpInfo } from '../types/IpInfo';

export function useIpInfo() {
  return useQuery({
    queryKey: ['ipInfo'],
    queryFn: async () => {
      const { data } = await axios.get<IpInfo>('https://ipapi.co/json/');
      return data;
    },
  });
}
